import React from "react";
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
const Gallery = () => {
    return (
        <div>
        <div class="tf-page-title">
        <div >
          <div class="row">
            <div class="col-12">
            
              <div class="heading text-center ">
              <h4 className='breadcrumbtitle'>Gallery</h4>
                <div className=' breadcrumb'>
                <Link to="/" style={{color:"black"}} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{marginTop:"0.5vh"}}/>

                <h6>Gallery</h6></div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
        <section className="flat-spacing-1">
            <div className="container">
                <div className="tf-grid-layout lg-col-3 tf-col-2">
                    <div className="collection-item hover-img">
                        <div className="collection-inner">
                            <a href="" className="collection-image img-style">
                                <img className="lazyload" data-src="images/collections/DSC03611.jpg" src="images/collections/DSC03611.jpeg"  alt="collection-img"/>
                            </a>
                            {/* <div className="collection-content">
                                <a href="" className="tf-btn collection-title hover-icon" style={{color:"black"}}><span>Suit</span><i className="icon icon-arrow1-top-left"></i></a>
                            </div> */}
                        </div>
                    </div>
                    <div className="collection-item hover-img">
                        <div className="collection-inner">
                            <a href="" className="collection-image img-style">
                                <img className="lazyload" data-src="images/collections/DSC03877.jpg" src="images/collections/DSC03877.jpg" alt="collection-img"/>
                            </a>
                            {/* <div className="collection-content">
                                <a href="" className="tf-btn collection-title hover-icon" style={{color:"black"}}><span>Blazer</span><i className="icon icon-arrow1-top-left"></i></a>
                            </div> */}
                        </div>
                    </div>
                    <div className="collection-item hover-img">
                        <div className="collection-inner">
                            <a href="" className="collection-image img-style">
                                <img className="lazyload" data-src="images/collections/DSC04170.jpg" src="images/collections/DSC04170.jpg" alt="collection-img"/>
                            </a>
                            {/* <div className="collection-content">
                                <a href="" className="tf-btn collection-title hover-icon" style={{color:"black"}}><span>Blazer</span><i className="icon icon-arrow1-top-left"></i></a>
                            </div> */}
                        </div>
                    </div>
                    <div className="collection-item hover-img">
                        <div className="collection-inner">
                            <a href="" className="collection-image img-style">
                                <img className="lazyload" data-src="images/collections/DSC04229.jpg" src="images/collections/DSC04229.jpg" alt="collection-img"/>
                            </a>
                            {/* <div className="collection-content">
                                <a href="" className="tf-btn collection-title hover-icon" style={{color:"black"}}><span>Blazer</span><i className="icon icon-arrow1-top-left"></i></a>
                            </div> */}
                        </div>
                    </div>
                    <div className="collection-item hover-img">
                        <div className="collection-inner">
                            <a href="" className="collection-image img-style">
                                <img className="lazyload" data-src="images/collections/DSC04562.jpg" src="images/collections/DSC04562.jpg" alt="collection-img"/>
                            </a>
                            {/* <div className="collection-content">
                                <a href="" className="tf-btn collection-title hover-icon" style={{color:"black"}}><span>Blazer</span><i className="icon icon-arrow1-top-left"></i></a>
                            </div> */}
                        </div>
                    </div>
                    <div className="collection-item hover-img">
                        <div className="collection-inner">
                            <a href="" className="collection-image img-style" >
                                <img className="lazyload" data-src="images/collections/DSC04573.jpg" src="images/collections/DSC04573.jpg" alt="collection-img"/>
                            </a>
                            {/* <div className="collection-content">
                                <a href="" className="tf-btn collection-title hover-icon" style={{color:"black"}}><span >Blazer</span><i className="icon icon-arrow1-top-left"></i></a>
                            </div> */}
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
        <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
        </div>
        );
}

export default Gallery